export const ON_BEGIN_PROFILE_FETCH = 'ON_BEGIN_PROFILE_FETCH';
export const ON_PROFILE_FETCH_SUCCESS = 'ON_PROFILE_FETCH_SUCCESS';
export const ON_PROFILE_FETCH_FAILED = 'ON_PROFILE_FETCH_FAILED';

export const ON_START_CREATING_DECK = 'ON_START_CREATING_DECK';
export const ON_START_EDITING_DECK = 'ON_START_EDITING_DECK';
export const ON_DECK_CREATION_CANCELLED = 'ON_DECK_CREATION_CANCELLED';
export const ON_DECK_CREATION_COMPLETE = 'ON_DECK_CREATION_COMPLETE';
export const ON_SEND_DECK = 'ON_SEND_DECK';

export const ON_START_FETCHING_DECKS = 'ON_START_FETCHING_DECKS';
export const ON_GET_DECKS_CANCELLED = 'ON_GET_DECKS_CANCELLED';
export const ON_GET_DECKS_COMPLETE = 'ON_GET_DECKS_COMPLETE';

export const ON_START_CREATING_CARD = 'ON_START_CREATING_CARD';
export const ON_CARD_CREATION_CANCELLED = 'ON_CARD_CREATION_CANCELLED';
export const ON_CARD_CREATION_COMPLETE = 'ON_CARD_CREATION_COMPLETE';
export const ON_SEND_CARD = 'ON_SEND_CARD';

export const ON_START_FETCHING_TAGS = 'ON_START_FETCHING_TAGS';
export const ON_DECK_TAGS_FETCH_FAILED = 'ON_DECK_TAGS_FETCH_FAILED';
export const ON_DECK_TAGS_FETCH_SUCCESS = 'ON_DECK_TAGS_FETCH_SUCCESS';

export const SET_SELECTED_TAGS = 'SET_SELECTED_TAGS';
export const CLEAR_SELECTED_TAGS = 'CLEAR_SELECTED_TAGS';

export const ON_START_FETCHING_CARDS = 'ON_START_FETCHING_CARDS';
export const ON_DECK_CARDS_FETCH_FAILED = 'ON_DECK_CARDS_FETCH_FAILED';
export const ON_DECK_CARDS_FETCH_SUCCESS = 'ON_DECK_CARDS_FETCH_SUCCESS';

export const ON_SELECT_DECK = 'ON_SELECT_DECK';
export const ON_GET_SINGLE_DECK_SUCCESS = 'ON_GET_SINGLE_DECK_SUCCESS';
export const ON_GET_SINGLE_DECK_FAILED = 'ON_GET_SINGLE_DECK_FAILED';

export const RECENT_DECKS_START = 'RECENT_DECKS_START';
export const RECENT_DECKS_SUCCESS = 'RECENT_DECKS_SUCCESS';
export const RECENT_DECKS_FAILED = 'RECENT_DECKS_FAILED';

export const TOGGLE_ANSWERS = 'TOGGLE_ANSWERS';

export const HAMBURGER_CLICKED = 'HAMBURGER_CLICKED';
export const ON_DELETE_CARD_SUCCESS = 'ON_DELETE_CARD_SUCCESS';
export const ON_DELETE_CARD_FAILED = 'ON_DELETE_CARD_FAILED';

export const ON_START_DELETE_DECK = 'ON_START_DELETE_DECK';
export const ON_DELETE_DECK_SUCCESS = 'ON_DELETE_DECK_SUCCESS';
export const ON_DELETE_DECK_FAILED = 'ON_DELETE_DECK_FAILED';

export const ON_UPDATE_CARD_START = 'ON_UPDATE_CARD_START';
export const ON_CARD_UPDATE_SUCCESS = 'ON_CARD_UPDATE_SUCCESS';
export const ON_CARD_UPDATE_CANCELLED = 'ON_CARD_UPDATE_CANCELLED';

export const ON_START_DELETE_CONFIRMATION = 'ON_START_DELETE_CONFIRMATION';
export const ON_DELETE_CONFIRMATION_SUCCESS = 'ON_DELETE_CONFIRMATION_SUCCESS';
export const ON_DELETE_CONFIRMATION_CANCELED =
  'ON_DELETE_CONFIRMATION_CANCELED';

export const ON_START_FETCH_SESSIONS = 'ON_START_FETCH_SESSIONS';
export const ON_FETCH_SESSIONS_FAILED = 'ON_FETCH_SESSIONS_FAILED';
export const ON_FETCH_SESSIONS_SUCCESS = 'ON_FETCH_SESSIONS_SUCCESS';

export const ON_START_FETCH_SINGLE_SESSION = 'ON_START_FETCH_SINGLE_SESSION';
export const ON_FETCH_SINGLE_SESSION_FAILED = 'ON_FETCH_SINGLE_SESSION_FAILED';
export const ON_FETCH_SINGLE_SESSION_SUCCESS =
  'ON_FETCH_SINGLE_SESSION_SUCCESS';

export const ON_START_CREATE_SESSIONS = 'ON_START_CREATE_SESSIONS';
export const ON_CREATE_SESSIONS_FAILED = 'ON_CREATE_SESSIONS_FAILED';
export const ON_CREATE_SESSIONS_SUCCESS = 'ON_CREATE_SESSIONS_SUCCESS';

export const ON_START_CARD_RATING = 'ON_START_CARD_RATING';
export const ON_CARD_RATING_SUCCESS = 'ON_CARD_RATING_SUCCESS';
export const ON_CARD_RATING_FAILED = 'ON_CARD_RATING_FAILED';

export const ON_START_GET_ALL_DECKS = 'ON_START_GET_ALL_DECKS';
export const ON_GET_ALL_DECKS_SUCCESS = 'ON_GET_ALL_DECKS_SUCCESS';
export const ON_GET_ALL_DECKS_FAILED = 'ON_GET_ALL_DECKS_FAILED';

export const ON_DECK_NAME_SEARCH = 'ON_DECK_NAME_SEARCH';

export const ON_START_FETCHING_CARD_OF_THE_DAY =
  'ON_START_FETCHING_CARD_OF_THE_DAY';
export const ON_CARD_OF_THE_DAY_FETCH_FAILED =
  'ON_CARD_OF_THE_DAY_FETCH_FAILED';
export const ON_CARD_OF_THE_DAY_FETCH_SUCCESS =
  'ON_CARD_OF_THE_DAY_FETCH_SUCCESS';

export const ON_START_UPDATE_ACCESS = 'ON_START_UPDATE_ACCESS';
export const ON_UPDATE_ACCESS_SUCCESS = 'ON_UPDATE_ACCESS_SUCCESS';
export const ON_UPDATE_ACCESS_FAIL = 'ON_UPDATE_ACCESS_FAIL';

export const ON_START_FETCH_FAV_TAGS = 'ON_START_FETCH_FAV_TAGS';
export const ON_FETCH_FAV_TAGS_SUCCESS = 'ON_FETCH_FAV_TAGS_SUCCESS';
export const ON_FETCH_FAV_TAGS_FAIL = 'ON_FETCH_FAV_TAGS_FAIL';

export const SESSION_COMPLETE = 'SESSION_COMPLETE';
